import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { FaTrophy, FaUsers, FaClipboardList, FaChalkboardTeacher } from "react-icons/fa"; // Import new icons from react-icons
import "./Interview.scss"; // Import the CSS file for styling

const Interview = () => {
  // State to track mobile view
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // State to track grid layout based on screen size
  const [gridTemplateColumns, setGridTemplateColumns] = useState('1fr 1fr'); // Default to 2 columns for desktop

  const updateGridColumns = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile); // Check if screen is mobile size
    setGridTemplateColumns(mobile ? '1fr' : '1fr 1fr'); // Set to 1 column for mobile, 2 columns for desktop
  };

  useEffect(() => {
    updateGridColumns(); // Set initial grid columns

    // Attach event listener to handle window resize
    window.addEventListener('resize', updateGridColumns);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateGridColumns);
    };
  }, []);

  // Define the styles for the grid
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: gridTemplateColumns,
    gap: '20px', // Add spacing between cards
  };

  // Define the titles, paths, icons, and corresponding descriptions for the cards
  const cardData = [
    {
      title: "Toppers Interview",
      path: "/freeresources/FRInterviewToppersInterview",
      icon: FaChalkboardTeacher, // Chalkboard teacher icon
      description: "Gain insights from the experiences of successful candidates."
    },
    {
      title: "Top Interviews",
      path: "/freeresources/FRInterviewTopInterviews",
      icon: FaTrophy, // Trophy icon
      description: "Discover the top interviews that set benchmarks for success."
    },
    {
      title: "Toppers List",
      path: "/freeresources/FRInterviewToppersList",
      icon: FaClipboardList, // Clipboard list icon
      description: "View a comprehensive list of top achievers."
    },
    {
      title: "Panel List",
      path: "/freeresources/FRInterviewPanelList",
      icon: FaUsers, // Users icon
      description: "Explore the panel of experts conducting the interviews."
    },
  ];

  return (
    <div className="section1-container">
      <div className="card-container" style={gridStyle}>
        {cardData.map((card, index) => (
          <Link to={card.path} key={index} className="card">
            <h4 style={{ fontSize: "18px" }}>
              <card.icon style={{ marginRight: '10px', color: "#DD5D59" }} /> {card.title} {/* Use the icon component */}
            </h4>
            <h6 className="cardh6" style={{ fontWeight: "600", fontSize: "17px" }}>{card.description}</h6> {/* Display the description */}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Interview;
